import { LeadIntent } from '../../api/models';
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from '../utils';

const ACTION_LOAD_INTENT_REQUEST = 'ENTITIES/LOAD_INTENT_REQUEST';
const ACTION_LOAD_INTENT_SUCCESS = 'INTENT/LOAD_INTENT_SUCCESS';
const ACTION_LOAD_INTENT_ERROR = 'INTENT/LOAD_INTENT_ERROR';

export interface IntentState {
  leadIntent: LeadIntent[];
  isLoading?: boolean;
  isLoaded?: boolean;
}

const initialState: IntentState = {
  leadIntent: [],
  isLoaded: false,
  isLoading: false,
};

type LoadIntentRequestActionType = IAction<typeof ACTION_LOAD_INTENT_REQUEST>;

type LoadIntentSuccessActionType = IActionWithPayload<
  typeof ACTION_LOAD_INTENT_SUCCESS,
  LeadIntent[]
>;

type LoadIntentErrorActionType = IAction<typeof ACTION_LOAD_INTENT_ERROR>;

type Actions =
  | LoadIntentRequestActionType
  | LoadIntentSuccessActionType
  | LoadIntentErrorActionType;

export const loadIntentRequestAction = (): LoadIntentRequestActionType => {
  return createAction(ACTION_LOAD_INTENT_REQUEST);
};

export const loadIntentSuccessAction = (
  data: LeadIntent[]
): LoadIntentSuccessActionType => {
  return createActionWithPayload(ACTION_LOAD_INTENT_SUCCESS, data);
};

export const loadIntentErrorAction = (): LoadIntentErrorActionType => {
  return createAction(ACTION_LOAD_INTENT_ERROR);
};

// reducer
export const leadIntentReducer = (
  state: IntentState = initialState,
  action: Actions
): IntentState => {
  switch (action.type) {
    case ACTION_LOAD_INTENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case ACTION_LOAD_INTENT_ERROR:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case ACTION_LOAD_INTENT_SUCCESS:
      return {
        ...state,
        leadIntent: action.payload,
        isLoading: false,
        isLoaded: true,
      };
    default:
      return state;
  }
};
